/**
 * AppleWalletLink — the "Hozzáadás Apple Wallet-hez" anchor, extracted verbatim
 * from PassDetail.tsx so PassDetail and the studio success card show the
 * identical control. When `saveUrl` is null (Google-only / not-yet-supported
 * mint) it renders the disabled "Hamarosan" button, byte-identical to the
 * previous inline PassDetail behavior.
 */

import { useT } from '../i18n';

export interface AppleWalletLinkProps {
  saveUrl: string | null;
  /** Extra classes to match the host layout (PassDetail passes `flex-1`). */
  className?: string;
}

export function AppleWalletLink({ saveUrl, className = '' }: AppleWalletLinkProps): JSX.Element {
  const t = useT();
  if (saveUrl) {
    // NOTE: no target="_blank". A .pkpass responds as a file download
    // (application/vnd.apple.pkpass), so target="_blank" opened a stray
    // about:blank tab on desktop (the file downloads, the popup tab stays
    // empty) — which reads as "nothing happened". A same-tab link downloads in
    // place on desktop and shows the Add-to-Wallet sheet on iPhone; `download`
    // hints the filename where the browser honors it.
    return (
      <a
        href={saveUrl}
        download="pass.pkpass"
        rel="noopener noreferrer"
        className={`btn-secondary ${className}`}
      >
        {t('wallet.appleDownload')}
      </a>
    );
  }
  return (
    <button
      disabled
      title={t('wallet.appleSoonTitle')}
      className={`btn-secondary cursor-not-allowed ${className}`}
    >
      {t('wallet.appleSoon')}
    </button>
  );
}
